import Vue from 'vue';

const success = (context, response) => {
  if (response.data.paginate) {
    context.lastPage = response.data.count - (context.limit * context.currentPage);
  }
  context.events = response.data.events;
  context.loading = false;
};

// When the request fails
const failed = (error, context) => {
  context.loading = false;
  toastr.error('Something went wrong');
};

export default (context, limit = null, page = null) => {
  let url = '/events';
  if ((limit != null && page != null)) {
    url = `/events?limit=${limit}&current_page=${page}`;
  }
  return Vue.$http.get(url).then((response) => {
    if (response && response.status === 200) {
      success(context, response);
    }
  })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/fetchEvents.js